import { accordionClasses, accordionSummaryClasses, lighten } from '@mui/material';
export const MuiAccordion = {
    defaultProps: {
        elevation: 10,
    },
    styleOverrides: {
        root: ({ theme }) => ({
            // Divider when collapsed
            borderBottomStyle: 'solid',
            borderBottomWidth: '1px',
            borderBottomColor: lighten(theme.palette.background.light, 1),
            '&:first-of-type': {
                borderTopLeftRadius: `var(--gp-radius-lg)`,
                borderTopRightRadius: `var(--gp-radius-lg)`,
                [`.${accordionSummaryClasses.root}`]: {
                    borderTopLeftRadius: `var(--gp-radius-lg)`,
                    borderTopRightRadius: `var(--gp-radius-lg)`,
                },
            },
            '&:last-of-type': {
                borderBottomLeftRadius: `var(--gp-radius-lg)`,
                borderBottomRightRadius: `var(--gp-radius-lg)`,
                [`.${accordionSummaryClasses.root}`]: {
                    borderBottomLeftRadius: `var(--gp-radius-lg)`,
                    borderBottomRightRadius: `var(--gp-radius-lg)`,
                },
            },
            [`&.${accordionClasses.expanded}`]: {
                '&:first-of-type': {
                    marginTop: 0,
                },
            },
            [`&:not(.${accordionClasses.expanded})::before`]: {
                height: 0,
            },
        }),
    },
};
export const MuiAccordionSummary = {
    styleOverrides: {
        root: {
            font: 'inherit',
            color: 'inherit',
        },
        content: ({ theme }) => ({
            [`&.${accordionClasses.expanded}`]: {
                margin: theme.spacing(4, 0),
            },
        }),
    },
};
